if(!customElements.get('press-logos')) {
  class ComponentPressLogos extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector('.keen-slider');

      this.carouselMode = this.dataset.carouselMode;
      this.carouselLoop = this.dataset.carouselLoop;
      this.carouselAutoplay = this.dataset.carouselAutoplay;
      this.carouselCenteredDesktop = this.dataset.carouselCenteredDesktop;
      this.carouselSpacingDesktop = this.dataset.carouselSpacingDesktop;
      this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
      this.carouselCenteredTablet = this.dataset.carouselCenteredTablet;
      this.carouselSpacingTablet = this.dataset.carouselSpacingTablet;
      this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
      this.carouselCenteredMobile = this.dataset.carouselCenteredMobile;
      this.carouselSpacingMobile = this.dataset.carouselSpacingMobile;
      this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;

      this.onFocusIn = this.onFocusIn.bind(this);
      document.addEventListener('focusin', this.onFocusIn);

      setTimeout(()=>{ //The timeout is for the customizer
        this.initSlider();
      }, 1);
    }

    disconnectedCallback() {
      document.removeEventListener('focusin', this.onFocusIn);
    }

    onFocusIn(event) {
      if (!this.sliderObj) return;
      if (this.contains(event.target)) {
        if (this.sliderObj.autoplayStop) this.sliderObj.autoplayStop();
        return;
      }
      if (document.activeElement && document.activeElement !== document.body) {
        if (this.sliderObj.autoplayStop) this.sliderObj.autoplayStop();
      }
    }

    initSlider() {
      if (!this.sliderElement) return;

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.carouselAutoplay = 0;
      }

      this.sliderObj = new KeenSlider(this.sliderElement, {
        mode: this.carouselMode,
        loop: this.carouselLoop=="true",
        dots: this.querySelector('.keen-dots'),
        prevButton: this.querySelector('.keen-arrow.prev'),
        nextButton: this.querySelector('.keen-arrow.next'),
        autoplay: this.carouselAutoplay,
        breakpoints: {
          '(min-width: 1051px)': {
            centered: this.carouselCenteredDesktop=="true",
            spacing: this.carouselSpacingDesktop,
            slidesPerView: this.slidesPerViewDesktop
          },
          '(min-width: 601px) and (max-width: 1050px)': {
            centered: this.carouselCenteredTablet=="true",
            spacing: this.carouselSpacingTablet,
            slidesPerView: this.slidesPerViewTablet
          },
          '(max-width: 600px)': {
            centered: this.carouselCenteredMobile=="true",
            spacing: this.carouselSpacingMobile,
            slidesPerView: this.slidesPerViewMobile
          }
        }
      });
    }
  }
  customElements.define('press-logos', ComponentPressLogos);
}
